import { render, staticRenderFns } from "./CockpitTree.vue?vue&type=template&id=1cf8b856&scoped=true"
import script from "./CockpitTree.vue?vue&type=script&lang=js"
export * from "./CockpitTree.vue?vue&type=script&lang=js"
import style0 from "./CockpitTree.vue?vue&type=style&index=0&id=1cf8b856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf8b856",
  null
  
)

export default component.exports